module.exports = __webpack_public_path__ + "static/media/Superior.26.66d0c31f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/rooms/superior/images/Superior.26.jpg
// module id = 695
// module chunks = 0